import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { BaseUrl, PrivateAxios,PrivateAxiosFile, url } from '../../environment/AxiosInstance'
import DataTable from 'react-data-table-component'
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { SuccessMessage, WaringMessage, ErrorMessage } from '../../environment/ToastMessage'
import moment from 'moment'
import AddCompany from './AddCompany'
import AddUser from '../user/AddUser'
import DeleteModel from '../../component/DeleteModel'
import DragDrop from '../CommonComponent/DragDrop';
import * as XLSX from 'xlsx';


function CompanyManagement() {

    const [data, setData] = useState([])
    const [dataAll, setDataAll] = useState([])
    const GetCompany = () => {
        axios.get(`${BaseUrl}active-company`)
            .then((res) => {
                setData(res.data.data)
                setDataAll(res.data.data)
            }).catch((err) => {
            })
    }



    const StatusChange = (id, status) => {
        setData(prevent => prevent.map(step =>
            step.id === id ? { ...step, status: status ? 1 : 0 } : step
        ))
        PrivateAxios.post('update-status', { id: id, status: status })
            .then((res) => {
                SuccessMessage(res.data.msg)
            }).catch((err) => {

            })
    }

    //==========Edit Company Permission==============//
    const [permissionEditId, serPermissionEditId] = useState("")
    const [companyEditData, setCompanyEditData] = useState({
        "id": "",
        "name": "",
        "tasktracker": 0,
        "checksheet": 0,
        "workflow": 0,
        "order_workflow": 0,
        "helpticket": 0,
        "renew_date": "",
        "link": ""
    })
    const getCompanyData = (id) => {
        PrivateAxios.get(`company/company-info/${id}`)
            .then((res) => {
                const { tasktracker, checksheet, workflow, order_workflow, helpticket, sales, project, renew_date, link } = res.data.data
                setCompanyEditData({ ...companyEditData, sales, project, tasktracker, checksheet, workflow, order_workflow, helpticket, renew_date, link: link });
            }).catch((err) => {

            })
    }

    const UpdateSubmit = (e) => {
        e.preventDefault();
        PrivateAxios.put(`company/company-update/${permissionEditId}`, companyEditData)
            .then((res) => {
                SuccessMessage(res.data.message);
                EditpermissionHide();
                GetCompany();
            }).catch((err) => {

            })
    }

    const [permissionEditModel, setEditpermissionModel] = useState(false);

    const EditpermissionShow = (data) => {
        setEditpermissionModel(true);
        serPermissionEditId(data.id);
        getCompanyData(data.id)
        setCompanyEditData({ ...companyEditData, id: data.id, name: data.company_name })
    }
    const EditpermissionHide = () => {
        setEditpermissionModel(false);
        serPermissionEditId("");
        setCompanyEditData({
            "id": "",
            "name": "",
            "tasktracker": 0,
            "checksheet": 0,
            "sales": 0,
            "project": 0,
            "workflow": 0,
            "order_workflow": 0,
            "helpticket": 0,
            "renew_date": ""
        })
    }

    const selectedColumns = [
        {
            name: 'Sl No.',
            selector: (row, index) => index + 1,
            width: "80px",
        },
        {
            name: "Name",
            selector: (row) => row.company_name,
            sortable: true,
            width: "250px",
        },
        {
            name: "Email",
            selector: (row) => row.company_email,
            sortable: true,
            reorder: true,
            width: "260px"
        },
        {
            name: "Phone Number",
            selector: (row) => row.company_phone,
            sortable: true,
            reorder: true,
            width: "180px"
        },
        {
            name: "GST NO.",
            selector: (row) => row.gst,
            sortable: true,
            reorder: true,
            width: "180px"
        },
        {
            name: "Main Company",
            selector: (row) => row.main_company_id == 0 ? "Main Company" : data.find(item => item.id == row.main_company_id).company_name,
            sortable: true,
            reorder: true,
            width: "180px"
        },
        {
            name: "Status",
            selector: (row) => row.status,
            sortable: true,
            reorder: true,
            width: "200px",
            cell: (row) => (
                <div className='col-12'>
                    <div className='form-group mb-0 d-flex align-items-center gap-2'>
                        <span className='fw-bold text-muted text-red'>Inactive</span>
                        <label className="custom-switch" >
                            <input type="checkbox" name='is_require_file' checked={row.status == 1} onChange={(e) => StatusChange(row.id, e.target.checked)} />
                            <div className="switch-slider switch-round" />
                        </label>
                        <span className='fw-bold text-success'>Active</span>
                    </div>
                </div>
            )
        },
        {
            name: "Renew Date",
            selector: (row) => row.company.renew_date,
            sortable: true,
            reorder: true,
            width: "200px",
            cell: (row) => (
                <div
                    className={`col-12 w-100 h-100 justify-content-center ${row.company?.renew_date && new Date() > new Date(row.company.renew_date)
                            ? 'bg-red'
                            : ''
                        }`}
                >
                    <div className='form-group mb-0 d-flex align-items-center gap-2'>

                        <span className='fw-bold'>{row.company.renew_date}</span>
                    </div>
                </div>
            )

        },
        {
            name: "Action",
            width: "170px",
            selector: (row) => '',
            cell: (row) => (
                <div className="d-flex">
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                View
                            </Tooltip>
                        }
                    >
                        <button className="me-1 table-action-btn" onClick={() => ShowModel(row)}>
                            <i className="fas fa-eye"></i>
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                Edit
                            </Tooltip>
                        }
                    >
                        <button className="me-1 table-action-btn" onClick={() => EditpermissionShow(row)}>
                            <i className="fas fa-pen"></i>
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                Add User
                            </Tooltip>
                        }
                    >
                        <button className="me-1 table-action-btn" onClick={() => ShoUserModel(row)}>
                            <i className="fas fa-user-plus"></i>
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                Activity Log
                            </Tooltip>
                        }
                    >
                        <button className="me-1 table-action-btn" onClick={() => ShowLog(row.id, row.company_name)}>
                            <i className="fas fa-history"></i>
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                Extend Date
                            </Tooltip>
                        }
                    >
                        <button className="me-1 table-action-btn" onClick={() => ExtendDateModel(row.id, row.company_name)}>
                            <i className="fa fa-retweet"></i>
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                User List
                            </Tooltip>
                        }
                    >
                        <button className="me-1 table-action-btn" onClick={() => UserShowModal(row.id, row.company_name)}>
                            <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 24 24" width={14}
                                height={14}
                                fill="currentColor"
                                className="">
                                <path d="M21,11h-5c-1.654,0-3,1.346-3,3v7c0,1.654,1.346,3,3,3h5c1.654,0,3-1.346,3-3v-7c0-1.654-1.346-3-3-3Zm-1,9h-3c-.553,0-1-.448-1-1s.447-1,1-1h3c.553,0,1,.448,1,1s-.447,1-1,1Zm0-4.003h-3c-.553,0-1-.448-1-1s.447-1,1-1h3c.553,0,1,.448,1,1s-.447,1-1,1ZM3,6C3,2.691,5.691,0,9,0s6,2.691,6,6-2.691,6-6,6S3,9.309,3,6ZM12.026,24H1c-.557,0-1.001-.46-1-1.017,.009-4.955,4.043-8.983,9-8.983h0c.688,0,1.356,.085,2,.232v6.768c0,1.13,.391,2.162,1.026,3Z" />
                            </svg>
                        </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                Bulk Upload Users
                            </Tooltip>
                        }
                    >
                        <button className="me-1 table-action-btn" onClick={() => handleBulkUpload(row.id, row.company_name)}>
                            <i className="fas fa-upload"></i>
                        </button>
                    </OverlayTrigger>

                </div>
            ),
        },
    ];


    const [viewModel, setViewModel] = useState(false);
    const [viewModelData, setViewModelData] = useState('');
    const ShowModel = (data) => {
        setViewModel(true)
        setViewModelData(data)
    }
    const HideModel = () => {
        setViewModel(false);
        setViewModelData('')
    }


    //==================Add Company========================//
    const [showAddCompany, setShowCompany] = useState(false)
    const ShowCompanyModel = () => {
        setShowCompany(true)
    }
    const HideCompanyModel = () => {
        setShowCompany(false)
    }

    //==================Add User========================//
    const [showAddUser, setShoUser] = useState(false)
    const [companyId, setCompanyId] = useState('')
    const ShoUserModel = (id) => {
        setShoUser(true)
        setCompanyId(id)
    }
    const HideUserModel = () => {
        setShoUser(false)
        setCompanyId('')
    }



    //==================End Add User Date Add========================//
    //
    const [msg, setMsg] = useState('')
    const [error, setError] = useState(false)
    const CreateSheet = () => {
        axios.get(`${BaseUrl}checksheet/checksheet-remainder`)
            .then((res) => {
                setError(false)
                setMsg(res.data.message)
            }).catch((err) => {

                setError(true)
                setMsg("error occur")
            })
    }

    const searchCompany = (e) => {
        const filteredItems = dataAll.filter((item) => {
            return item && item.company_name && item.company_name.toLowerCase().replace(/\s+/g, '').includes(e.target.value.toLowerCase().replace(/\s+/g, ''))
        }
        );
        setData(filteredItems);
    }
    //===========Activity Log=================//
    const [logModal, setLogModal] = useState(false);
    const [compName, setComName] = useState('')
    const [activeLog, setActivelog] = useState('')
    const [activeLogAll, setActivelogAll] = useState('')

    const getLogData = (id) => {
        PrivateAxios.get(`company/activity-log/${id}`)
            .then((res) => {
                setActivelog(res.data.data)
                setActivelogAll(res.data.data)
            }).catch((err) => {

            })
    }

    const ShowLog = (data, name) => {
        setComName(name);
        getLogData(data)
        setLogModal(true)
    }
    const CloseLog = () => {
        setComName("");
        setLogModal(false)
    }


    const search = (e) => {

        const filteredItems = activeLogAll.filter((item) => {
            return item && item.message && item.message.toLowerCase().replace(/\s+/g, '').includes(e.target.value.toLowerCase().replace(/\s+/g, ''))
        }
        );
        setActivelog(filteredItems);
    }

    const AllActivityColumns = [
        {
            name: 'Sl No.',
            selector: (row, index) => index + 1,
            width: "80px",
        },
        {
            name: "User Name",
            selector: (row) => row.user.name,
            sortable: true,
            width: "250px",
        },
        {
            name: "Message",
            selector: (row) => row.message,
            sortable: true,
            reorder: true,
            maxWidth: "500px",
            cell: (row) => (
                <div style={{
                    whiteSpace: "normal",
                    overflow: "hidden",
                    display: "-webkit-box",
                    WebkitBoxOrient: "vertical",
                }}>
                    {row.message}
                </div>
            ),
        },
        {
            name: "Date",
            selector: (row) => moment(row.created_at).format("DD-MM-YYYY hh:mm A"),
            sortable: true,
            reorder: true,
            width: "260px"
        },
    ];

    //===============User List================//
    const [UserModal, setUserModal] = useState(false);
    const [UserModalName, setUserModalName] = useState("");
    const [UserList, setUserList] = useState([]);
    const GetuserList = (id) => {
        PrivateAxios.get(`company/user-list/${id}`)
            .then((res) => {
                setUserList(res.data.data);
            }).catch((err) => {

            })
    }
    const UserShowModal = (id, name) => {
        setUserModal(true);
        GetuserList(id)
        setUserModalName(name)
    }
    const UserCloseModal = () => {
        setUserModal(false);
        setUserModalName("")
    }

    const [deleteShow, setDeleteShow] = useState(false);
    const [deleteShowValue, setDeleteShowValue] = useState('');
    const deleteModalClose = () => {
        setDeleteShowValue('')
        setDeleteShow(false);
    }
    const deleteModalShow = (id) => {
        setDeleteShowValue(id)
        setDeleteShow(true)

    };

    const DeleteUser = () => {
        PrivateAxios.delete(`user/delete-user/${deleteShowValue}`)
            .then((res) => {
                SuccessMessage(res.data.msg)
                setUserList(prevent => prevent.filter(item => item.id != deleteShowValue))
                deleteModalClose();
            }).catch((err) => {

            })

    }

    const AllUserColumns = [
        {
            name: 'Sl No.',
            selector: (row, index) => index + 1,
            width: "80px",
        },
        {
            name: "User Name",
            selector: (row) => row.name,
            sortable: true,
            width: "250px",
        },
        {
            name: "Email",
            selector: (row) => row.email,
            sortable: true,
            maxWidth: "250px",
        },
        {
            name: "Phone",
            selector: (row) => row.phone_number,
            sortable: true,
            reorder: true,
            width: "260px"
        },
        {
            name: "Action",
            width: "180px",
            selector: (row) => null,
            cell: (row) => (
                <div className="d-flex">

                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip>
                                Delete
                            </Tooltip>
                        }
                    >
                        <button className="me-1 table-action-btn" onClick={() => deleteModalShow(row.id)}>
                            <i className="fas fa-trash-alt text-exp-red"></i>
                        </button>
                    </OverlayTrigger>
                </div >
            ),
        },
    ];

    useEffect(() => {
        GetCompany()

    }, []);




    //=================================Create Coupon=========================//
    const [couponDate, setcouponDate] = useState(false)
    const [couponAllData, setcouponAllData] = useState([]);
    const [couponData, setCouponData] = useState({
        'code': "",
        'amount': "",
        'date': ""
    })
    const CouponDateModel = () => {
        setcouponDate(true)
    }
    const CouponDateModelHide = () => {
        setcouponDate(false);
        setCouponData({
            'code': "",
            'amount': "",
            'date': ""
        })
    }

    const SubmitCoupon = (e) => {
        e.preventDefault();
        const payload = {
            code: couponData.code,
            amount: couponData.amount,
            date: couponData.date,
        }
        axios.post(`${BaseUrl}create-coupon`, payload)
            .then((res) => {
                SuccessMessage(res.data.msg);
                CouponDateModelHide();
                GetCoupon();
            }).catch((err) => {

            })
    }
    const GetCoupon = () => {
        axios.get(`${BaseUrl}get-coupon`)
            .then((res) => {
                setcouponAllData(res.data.data);
            }).catch((err) => {

            })
    }

    useEffect(() => {
        GetCoupon();
    }, [])

    //=================================Add  Date=========================//
    const [extandDate, setExtandDate] = useState(false)
    const [extandData, setExtandData] = useState({
        'id': "",
        "companyName": "",
        "date": ""
    });
    // const [couponData, setCouponData] = useState({
    //     'code': "",
    //     'amount': "",
    //     'date': ""
    // })
    const ExtendDateModel = (id, companyName) => {
        setExtandData({ ...extandData, id: id, companyName: companyName })
        setExtandDate(true)
    }
    const ExtandDateModelHide = () => {
        setExtandDate(false);
        setExtandData({ id: '', companyName: '', date: '' })
    }

    const SubmitExtandDate = (e) => {
        e.preventDefault();
        const payload = {
            id: extandData.id,
            date: extandData.date,
        }

        // axios.post(`${BaseUrl}create-coupon`, payload)
        //     .then((res) => {
        //         SuccessMessage(res.data.msg);
        //         CouponDateModelHide();
        //         GetCoupon();
        //     }).catch((err) => {
        //     })
    }

    //=================================Price All=========================//

    const [price, setPrice] = useState({
        'task_price_monthly': "",
        'task_price_yearly': "",
        "sheet_price_monthly": "",
        "sheet_price_yearly": "",
        "flow_price_monthly": "",
        "flow_price_yearly": ""
    });
    const GetPrice = () => {
        axios.get(`${BaseUrl}get-price`)
            .then((res) => {
                setPrice({
                    ...price, task_price_monthly: JSON.parse(res.data.data?.task_price)?.monthly,
                    task_price_yearly: JSON.parse(res.data.data?.task_price)?.yearly, sheet_price_monthly: JSON.parse(res.data.data?.sheet_price)?.monthly,
                    sheet_price_yearly: JSON.parse(res.data.data?.sheet_price)?.yearly, flow_price_monthly: JSON.parse(res.data.data?.flow_price)?.monthly,
                    flow_price_yearly: JSON.parse(res.data.data?.flow_price)?.yearly,
                });
            }).catch((err) => {

            })
    }

    const SubmitDataPrice = (e) => {
        e.preventDefault();
        if (!price.task_price_monthly || !price.task_price_yearly || !price.sheet_price_monthly || !price.sheet_price_yearly || !price.flow_price_monthly || !price.flow_price_yearly) {
            WaringMessage("Filled All  field !")
            return;
        }
        const payload = {
            task_price: JSON.stringify({ monthly: price.task_price_monthly, yearly: price.task_price_yearly }),
            sheet_price: JSON.stringify({ monthly: price.sheet_price_monthly, yearly: price.sheet_price_yearly }),
            flow_price: JSON.stringify({ monthly: price.flow_price_monthly, yearly: price.flow_price_yearly })
        }
        axios.post(`${BaseUrl}create-price`, payload)
            .then((res) => {
                SuccessMessage(res.data.msg);
                CouponDateModelHide();
                GetPrice();
            }).catch((err) => {
            })
    }
    useEffect(() => {
        GetPrice();
    }, [])

    //==================Bulk User Upload========================//
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [bulkUploadCompanyId, setBulkUploadCompanyId] = useState(null);
    const [bulkUploadFiles, setBulkUploadFiles] = useState([]);
    const [bulkUploadErrors, setBulkUploadErrors] = useState([]);

    const handleBulkUpload = (companyId, companyName) => {
        setBulkUploadCompanyId({ id: companyId, name: companyName });
        setShowBulkUploadModal(true);
        setBulkUploadFiles([]);
        setBulkUploadErrors([]);
    };

    const handleCloseBulkUpload = () => {
        setShowBulkUploadModal(false);
        setBulkUploadCompanyId(null);
        setBulkUploadFiles([]);
        setBulkUploadErrors([]);
    };

    const submitBulkUpload = () => {
        if (bulkUploadFiles.length <= 0) {
            WaringMessage("Please select user list file!");
            return;
        }
        
        let formData = new FormData();
        formData.append("file", bulkUploadFiles[0]);
        
        PrivateAxiosFile.post(`setting/bulk-user-upload/${bulkUploadCompanyId.id}`, formData)
            .then((res) => {
                handleCloseBulkUpload();
                SuccessMessage(res.data.message);
                if (res.data.errors && res.data.errors.length > 0) {
                    setBulkUploadErrors(res.data.errors);
                    setShowBulkUploadModal(true); // Show errors
                }
            }).catch((err) => {
                ErrorMessage(err.response?.data?.message || "Upload failed");
            });
    };

    const downloadSampleExcel = () => {
        let headers = ["Name", "Email", "Phone", "Phone ISD", "WhatsApp Number", "WhatsApp ISD", "Password", "Department"];
        const sampleData = [
            ["John Doe", "john@example9.com", "9876543215", "91", "9876543219", "91", "password123",],
            ["Jane Smith", "jane@example9.com", "9876543221", "91", "9876543214", "91", "password456",]
        ];
        
        const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sampleData]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Users');
        XLSX.writeFile(workbook, `BulkUserUpload_Sample.xlsx`);
    };

    return (
        <React.Fragment>
            <div className="p-4">
                <div className='card'>

                    <div className='card-header d-flex flex-wrap justify-content-between align-items-center'>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Coupon Details <span className="text-exp-red">*</span></label>
                                <select id="taskPriority" className='form-control' name="priority">
                                    {
                                        couponAllData.length > 0 ? couponAllData.map((data) => (
                                            <option value="low">{data.code} -- RS. {data.amount}  -- Date. {moment(data.date).format("DD-MM-YYYY")}</option>
                                        ))
                                            : ""
                                    }

                                </select>
                            </div>
                        </div>
                        <button className="btn btn-exp-green ms-auto me-0" onClick={CouponDateModel}>
                            {/* <i className="fas fa-user-add me-2"></i>Create Company sidebar-nav-icon fi fi-ss-building */}
                            <i className="fas fa-plus me-2"></i>Create Coupon
                        </button>
                    </div>
                    <div className='card-header d-flex flex-wrap gap-2 justify-content-between align-items-center'>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label className="form-label">TaskTracker Monthly Price<span className="text-exp-red">*</span></label>
                                <input type="number" required className="form-control" value={price.task_price_monthly} onChange={(e) => setPrice({ ...price, task_price_monthly: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label className="form-label">TaskTracker Yearly Price<span className="text-exp-red">*</span></label>
                                <input type="number" required className="form-control" value={price.task_price_yearly} onChange={(e) => setPrice({ ...price, task_price_yearly: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label className="form-label">CheckSheet Monthly Price<span className="text-exp-red">*</span></label>
                                <input type="number" required className="form-control" value={price.sheet_price_monthly} onChange={(e) => setPrice({ ...price, sheet_price_monthly: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label className="form-label">CheckSheet Yearly Price<span className="text-exp-red">*</span></label>
                                <input type="number" required className="form-control" value={price.sheet_price_yearly} onChange={(e) => setPrice({ ...price, sheet_price_yearly: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label className="form-label">WorkFlow Monthly Price<span className="text-exp-red">*</span></label>
                                <input type="number" required className="form-control" value={price.flow_price_monthly} onChange={(e) => setPrice({ ...price, flow_price_monthly: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-3'>
                            <div className="form-group">
                                <label className="form-label">WorkFlow Yearly Price<span className="text-exp-red">*</span></label>
                                <input type="number" required className="form-control" value={price.flow_price_yearly} onChange={(e) => setPrice({ ...price, flow_price_yearly: e.target.value })} />
                            </div>
                        </div>

                        <button className="btn btn-exp-green ms-auto me-0" onClick={SubmitDataPrice}>
                            {/* <i className="fas fa-user-add me-2"></i>Create Company sidebar-nav-icon fi fi-ss-building */}
                            Create Price
                        </button>
                    </div>
                </div>
                {
                    msg ?
                        <div className={`alert ${error ? 'alert-warning' : 'alert-success'} alert-dismissible fade show`} role="alert">
                            <p>{msg}</p>
                            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                        </div> : ""
                }

                <div className='card mt-3'>
                    <div className='card-header d-flex flex-wrap justify-content-between align-items-center'>
                        <h3 className="card-title">Company List</h3>
                        <button className="btn btn-exp-green ms-auto me-0" onClick={ShowCompanyModel}>
                            {/* <i className="fas fa-user-add me-2"></i>Create Company sidebar-nav-icon fi fi-ss-building */}
                            <i className="fas fa-plus me-2"></i>Create Company
                        </button>
                    </div>
                    <div className='card-body p-0'>
                        <div className='d-flex w-100 align-items-center my-3 px-5'>
                            <span className='me-2 fw-medium text-muted'>Search:</span><input className='form-control' placeholder='company name' onChange={(e) => searchCompany(e)} />
                        </div>
                        {!data.length > 0 ?
                            <div div className="w-100">
                                <div className="card bg-warning-light mb-0">
                                    <div className="card-body">
                                        <div className="exp-no-data-found text-exp-red">
                                            <img className="task-img mb-3" src={process.env.PUBLIC_URL + 'assets/images/search-no-record-found.webp'} alt="No task" />
                                            <h6>No Record Found</h6>
                                        </div>
                                    </div>
                                </div>
                            </div> :
                            <>
                                <div className="table-view" >

                                    {/* <div className='d-flex justify-content-between flex-wrap align-items-center pt-3 px-3'>
                                        <div className='table-button-group mb-3'>
                                            <button className='btn table-export-btn' onClick={generateExcel} >
                                                <img src={process.env.PUBLIC_URL + 'assets/images/file-csv.svg'} alt="icon" />
                                            </button>
                                            <button className='btn table-export-btn' onClick={generatePdf}>
                                                <img src={process.env.PUBLIC_URL + 'assets/images/file-pdf.svg'} alt="icon" />
                                            </button>
                                            <button className='btn table-export-btn' onClick={generatePrint}>
                                                <img src={process.env.PUBLIC_URL + 'assets/images/print.svg'} alt="icon" />
                                            </button>
                                        </div>
                                        <div className='d-flex align-items-center mb-3 ms-auto'>
                                            <label className='mr-2 mb-0'>Search: </label>
                                            <input type='text' placeholder='Type here...' onChange={handleKeyUpSearch} className='form-control form-control-sm' />
                                        </div>
                                    </div> */}

                                    <DataTable
                                        columns={selectedColumns}
                                        data={data}
                                        pagination={[5, 10, 25, 50]}
                                        theme="solarized"
                                        striped
                                        className='custom-table-wrap checklist-table-striped'
                                    //customStyles={customStyles}
                                    />
                                </div>
                            </>
                        }
                    </div>
                </div>
            </div>


            <Modal id="viewUserModal" show={viewModel} onHide={HideModel} backdrop="static" keyboard={false} centered size="lg">
                <Modal.Header closeButton className="gth-blue-light-bg">
                    <Modal.Title className="gth-modal-title">
                        <h5 className="profile-name text-nowrap text-truncate">{viewModelData && viewModelData.company_name}</h5>

                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='pb-1'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Company Name</label>
                                <p className="mb-0">{viewModelData && viewModelData.company_name}</p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Company Email</label>
                                <p className="mb-0">{viewModelData && viewModelData.company_email}</p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Company Phone</label>
                                <p className="mb-0">{viewModelData.company_phone ? `+${viewModelData && viewModelData.c_p_isd} ${viewModelData && viewModelData.company_phone}` : ""}</p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Alternate Number</label>
                                <p className="mb-0">{viewModelData.company_alternate_phone ? `+${viewModelData && viewModelData.alternet_p_isd} ${viewModelData && viewModelData.company_alternate_phone}` : ""}</p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Address</label>
                                <p className="mb-0">{viewModelData && viewModelData.address} </p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Contact Name</label>
                                <p className="mb-0">{viewModelData && viewModelData.contact_name} </p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Contact Email</label>
                                <p className="mb-0">{viewModelData && viewModelData.contact_email} </p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Contact phone</label>
                                <p className="mb-0">+{viewModelData && viewModelData.p_isd} {viewModelData && viewModelData.contact_phone}</p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Whatsapp Number</label>
                                <p className="mb-0">+{viewModelData && viewModelData.w_isd} {viewModelData && viewModelData.whatsapp_number} </p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Start Date</label>
                                <p className="mb-0">{viewModelData && moment(viewModelData.start_date).format("DD-MMMM-YYYY")} </p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Renew Type</label>
                                <p className="mb-0">{viewModelData && viewModelData.renew_type}</p>
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Renew Date</label>
                                <p className="mb-0">{viewModelData && moment(viewModelData.renew_date).format("DD-MMMM-YYYY")}</p>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal id="viewUserLogModal" show={logModal} onHide={CloseLog} backdrop="static" keyboard={false} centered size="xl">
                <Modal.Header closeButton className="gth-blue-light-bg">
                    <Modal.Title className="gth-modal-title">
                        <h5 className="profile-name text-nowrap text-truncate mb-0">{compName && compName}</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='pb-1'>
                    <div className='d-flex w-100 align-items-center mb-3'>
                        <span className='me-2 fw-medium'>Search:</span><input className='form-control' onChange={(e) => search(e)} />
                    </div>
                    <DataTable
                        columns={AllActivityColumns}
                        data={activeLog}
                        pagination={[5, 10, 25, 50]}
                        theme="solarized"
                        striped
                        className='custom-table-wrap checklist-table-striped'
                    //customStyles={customStyles}
                    />
                </Modal.Body>
            </Modal>

            {/* ====================User List Modal===================== */}
            <Modal id="viewUserListModal" show={UserModal} onHide={UserCloseModal} backdrop="static" keyboard={false} centered size="xl">
                <Modal.Header closeButton className="gth-blue-light-bg">
                    <Modal.Title className="gth-modal-title">
                        <h5 className="profile-name text-nowrap text-truncate mb-0">{UserModalName && UserModalName}</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='pb-1'>
                    {/* <div className='d-flex w-100 align-items-center mb-3'>
                        <span className='me-2 fw-medium'>Search:</span><input className='form-control' onChange={(e) => search(e)} />
                    </div> */}
                    <DataTable
                        columns={AllUserColumns}
                        data={UserList}
                        pagination={[5, 10, 25, 50]}
                        theme="solarized"
                        striped
                        className='custom-table-wrap checklist-table-striped'
                    //customStyles={customStyles}
                    />
                </Modal.Body>
            </Modal>

            {/* =======================Edit Company=================== */}
            <Modal id="viewUserListModal" show={permissionEditModel} onHide={EditpermissionHide} backdrop="static" keyboard={false} centered size="xl">
                <Modal.Header closeButton className="gth-blue-light-bg">
                    <Modal.Title className="gth-modal-title">
                        <h5 className="profile-name text-nowrap text-truncate mb-0">{companyEditData && companyEditData.name}</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='pb-1'>
                    <form onSubmit={UpdateSubmit}>
                        <div className="form-group">
                            <label className="form-label">Permission <span className='text-danger'>*</span></label>
                            <div className="d-flex flex-wrap">
                                <label className="custom-checkbox me-3 mb-2">
                                    <input type="checkbox" checked={companyEditData.checksheet == 1 && companyEditData.tasktracker == 1 && companyEditData.workflow == 1} onChange={(e) => {
                                        e.target.checked ? setCompanyEditData({ ...companyEditData, tasktracker: 1, checksheet: 1, workflow: 1, sales:1,project:1}) : setCompanyEditData({ ...companyEditData, tasktracker: 0, checksheet: 0, workflow: 0, helpticket: 0 })
                                    }} />
                                    <span className="checkmark" />
                                    <span className="text-">All</span>
                                </label>
                                <label className="custom-checkbox me-3 mb-2">
                                    <input
                                        type="checkbox" checked={companyEditData.tasktracker == 1} onChange={(e) => { e.target.checked ? setCompanyEditData({ ...companyEditData, tasktracker: 1 }) : setCompanyEditData({ ...companyEditData, tasktracker: 0 }) }}
                                    />
                                    <span className="checkmark" />
                                    <span className="text-">Task Tracker</span>
                                </label>
                                <label className="custom-checkbox me-3 mb-2">
                                    <input
                                        type="checkbox" checked={companyEditData.checksheet == 1} onChange={(e) => { e.target.checked ? setCompanyEditData({ ...companyEditData, checksheet: 1 }) : setCompanyEditData({ ...companyEditData, checksheet: 0 }) }}
                                    />
                                    <span className="checkmark" />
                                    <span className="text-">Check Sheet</span>
                                </label>
                                <label className="custom-checkbox me-3 mb-2">
                                    <input
                                        type="checkbox" checked={companyEditData.workflow == 1} onChange={(e) => { e.target.checked ? setCompanyEditData({ ...companyEditData, workflow: 1 }) : setCompanyEditData({ ...companyEditData, workflow: 0 }) }}
                                    />
                                    <span className="checkmark" />
                                    <span className="text-">Work Flow</span>
                                </label>
                                <label className="custom-checkbox me-3 mb-2">
                                    <input
                                        type="checkbox" checked={companyEditData.order_workflow == 1} onChange={(e) => { e.target.checked ? setCompanyEditData({ ...companyEditData, order_workflow: 1 }) : setCompanyEditData({ ...companyEditData, order_workflow: 0 }) }}
                                    />
                                    <span className="checkmark" />
                                    <span className="text-">Order Work Flow</span>
                                </label>
                                <label className="custom-checkbox me-3 mb-2">
                                    <input
                                        type="checkbox" checked={companyEditData.project == 1} onChange={(e) => { e.target.checked ? setCompanyEditData({ ...companyEditData, project: 1 }) : setCompanyEditData({ ...companyEditData, project: 0 }) }}
                                    />
                                    <span className="checkmark" />
                                    <span className="text-">Project</span>
                                </label>
                                <label className="custom-checkbox me-3 mb-2">
                                    <input
                                        type="checkbox" checked={companyEditData.sales == 1} onChange={(e) => { e.target.checked ? setCompanyEditData({ ...companyEditData, sales: 1 }) : setCompanyEditData({ ...companyEditData, sales: 0 }) }}
                                    />
                                    <span className="checkmark" />
                                    <span className="text-">Sales</span>
                                </label>
                                {/* <label className="custom-checkbox me-3 mb-2">
                                    <input
                                        type="checkbox" checked={companyEditData.helpticket == 1} onChange={(e) => { e.target.checked ? setCompanyEditData({ ...companyEditData, helpticket: 1 }) : setCompanyEditData({ ...companyEditData, helpticket: 0 }) }}
                                    />
                                    <span className="checkmark" />
                                    <span className="text-">Help Ticket</span>
                                </label> */}
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Renew Date <span className="text-exp-red">*</span></label>
                                <input type="date" required className="form-control" onChange={(e) => setCompanyEditData({ ...companyEditData, renew_date: e.target.value })} value={companyEditData.renew_date} />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Button Link</label>
                                <input type="text" className="form-control" onChange={(e) => setCompanyEditData({ ...companyEditData, link: e.target.value })} value={companyEditData.link} />
                            </div>
                        </div>
                        {/* <div className='d-flex w-100 align-items-center mb-3'>
                        <span className='me-2 fw-medium'>Search:</span><input className='form-control' onChange={(e) => search(e)} />
                    </div> */}
                        {/* <DataTable
                        columns={AllUserColumns}
                        data={UserList}
                        pagination={[5, 10, 25, 50]}
                        theme="solarized"
                        striped
                        className='custom-table-wrap checklist-table-striped'
                    //customStyles={customStyles}
                    /> */}
                        <Modal.Footer>
                            <button className='btn btn-exp-green'>
                                Update
                            </button>
                        </Modal.Footer>
                    </form>
                </Modal.Body>
            </Modal>

            {/* ======================Add User=========================== */}
            <AddUser editUserShow={showAddUser} editUserModalClose={HideUserModel} companyId={companyId.id} companyEmail={companyId.company_email} />

            {/* ======================Add Company=========================== */}
            <AddCompany editUserShow={showAddCompany} editUserModalClose={HideCompanyModel} GetCompany={GetCompany} />

            {/* ======================renew company Company=========================== */}

            {/* ======================Add Date=========================== */}
            <Modal id="viewUserListModal" show={couponDate} onHide={CouponDateModelHide} backdrop="static" keyboard={false} centered size="xl">
                <Modal.Header closeButton className="gth-blue-light-bg">
                    <Modal.Title className="gth-modal-title">
                        <h5 className="profile-name text-nowrap text-truncate mb-0">{companyEditData && companyEditData.name}</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='pb-1'>
                    <form onSubmit={SubmitCoupon}>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Coupon Code <span className="text-exp-red">*</span></label>
                                <input type="text" required className="form-control" value={couponData.code} onChange={(e) => setCouponData({ ...couponData, code: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Amount <span className="text-exp-red">*</span></label>
                                <input type="number" required className="form-control" value={couponData.amount} onChange={(e) => setCouponData({ ...couponData, amount: e.target.value })} />
                            </div>
                        </div>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Expire Date <span className="text-exp-red">*</span></label>
                                <input type="date" required className="form-control" value={couponData.date} onChange={(e) => setCouponData({ ...couponData, date: e.target.value })} />
                            </div>
                        </div>
                        <Modal.Footer>

                            <button className='btn btn-exp-secondary' type='button' onClick={CouponDateModelHide}>
                                Cancel
                            </button>
                            <button className='btn btn-exp-green'>
                                Create
                            </button>
                        </Modal.Footer>
                    </form>
                </Modal.Body>
            </Modal>

            {/* ======================Add Date=========================== */}
            <Modal id="viewUserListModal" show={extandDate} onHide={ExtandDateModelHide} backdrop="static" keyboard={false} centered size="xl">
                <Modal.Header closeButton className="gth-blue-light-bg">
                    <Modal.Title className="gth-modal-title">
                        <h5 className="profile-name text-nowrap text-truncate mb-0">{extandData && extandData.companyName}</h5>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='pb-1'>
                    <form onSubmit={SubmitExtandDate}>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label className="form-label">Extant Date <span className="text-exp-red">*</span></label>
                                <input type="date" required className="form-control" value={couponData.date} onChange={(e) => setCouponData({ ...couponData, date: e.target.value })} />
                            </div>
                        </div>
                        <Modal.Footer>
                            <button className='btn btn-secondary' type='button' onClick={ExtandDateModelHide}>
                                Cancel
                            </button>
                            <button className='btn btn-exp-green'>
                                Update
                            </button>
                        </Modal.Footer>
                    </form>
                </Modal.Body>
            </Modal>

            {/* Bulk Upload Modal */}
            <Modal
                show={showBulkUploadModal}
                onHide={handleCloseBulkUpload}
                backdrop="static"
                keyboard={false}
                size={bulkUploadErrors.length > 0 ? "xl" : "lg"}
                centered
            >
                <Modal.Header closeButton className="gth-blue-light-bg">
                    <Modal.Title className="gth-modal-title">
                        <i className="fas fa-upload me-2"></i>
                        Bulk Upload Users - {bulkUploadCompanyId?.name}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className='pb-1'>
                    {bulkUploadErrors.length === 0 ? (
                        <>
                            <div className="alert alert-info">
                                <i className="fas fa-info-circle me-2"></i>
                                Upload an Excel file with user details. Make sure to follow the sample format.
                            </div>
                            
                            <div className="mb-3">
                                <button 
                                    className="btn btn-outline-success btn-sm"
                                    onClick={downloadSampleExcel}
                                >
                                    <i className="fas fa-download me-2"></i>
                                    Download Sample Excel
                                </button>
                            </div>
                            
                            <DragDrop 
                                type="XLSX" 
                                setFiles={setBulkUploadFiles} 
                                files={bulkUploadFiles} 
                                accept={{
                                    'application/vnd.ms-excel': ['.xls', '.xlsx'],
                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
                                }} 
                            />
                        </>
                    ) : (
                        <div>
                            <div className="alert alert-warning">
                                <i className="fas fa-exclamation-triangle me-2"></i>
                                Some users could not be created. Please check the errors below:
                            </div>
                            
                            <div className="table-responsive" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                <table className="table table-sm table-striped">
                                    <thead className="table-dark sticky-top">
                                        <tr>
                                            <th>Row</th>
                                            <th>Errors</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bulkUploadErrors.map((error, index) => (
                                            <tr key={index}>
                                                <td>{error.row}</td>
                                                <td>
                                                    <ul className="mb-0 ps-3">
                                                        {error.errors.map((err, i) => (
                                                            <li key={i} className="text-danger small">{err}</li>
                                                        ))}
                                                    </ul>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button 
                        type="button" 
                        className="btn btn-secondary" 
                        onClick={handleCloseBulkUpload}
                    >
                        Close
                    </button>
                    {bulkUploadErrors.length === 0 && (
                        <button 
                            type="button" 
                            className="btn btn-primary" 
                            onClick={submitBulkUpload}
                            disabled={bulkUploadFiles.length === 0}
                        >
                            <i className="fas fa-upload me-2"></i>
                            Upload Users
                        </button>
                    )}
                </Modal.Footer>
            </Modal>

            <DeleteModel deleteShow={deleteShow} deleteModalClose={deleteModalClose} deleteAction={DeleteUser} />
        </React.Fragment>
    )
}

export default CompanyManagement
